export default __webpack_public_path__ + "assets/93ef5b330ea02a2f817bfc64b800d68e.jpg";